// MOMKIS - Popup newsletter (offre de bienvenue -10 %)
//
// Règle absolue : ne jamais afficher la popup tant que le visiteur n'a pas
// fait de choix sur la bannière cookies native Shopify (ou tant qu'aucune
// bannière n'est requise dans sa région). Utilise exclusivement l'API
// Customer Privacy officielle de Shopify :
//   - window.Shopify.loadFeatures(...) pour garantir sa disponibilité
//   - window.Shopify.customerPrivacy.shouldShowBanner() pour savoir si un
//     choix est encore attendu
//   - l'événement natif "visitorConsentCollected" (document.addEventListener)
//     pour réagir au choix réel de l'utilisateur
// Jamais de lecture du DOM de la bannière, jamais de setInterval : le
// comportement reste robuste même si Shopify change le markup de sa
// bannière.
//
// Le formulaire lui-même est le formulaire client natif Shopify
// ({% form 'customer' %}), qui recharge la page à la soumission — aucune
// interception AJAX ici, exactement comme sections/momkis-pdp-final-cta.liquid
// et sections/momkis-footer-newsletter.liquid.

(function () {
  var STORAGE_SUBSCRIBED = 'momkis_newsletter_subscribed';
  var STORAGE_DISMISSED_UNTIL = 'momkis_newsletter_dismissed_until';
  var SESSION_SHOWN = 'momkis_newsletter_shown_session';

  function getPopup() {
    return document.querySelector('[data-momkis-newsletter-popup]');
  }

  function isSubscribed() {
    try {
      return localStorage.getItem(STORAGE_SUBSCRIBED) === 'true';
    } catch (e) {
      return false;
    }
  }

  function markSubscribed() {
    try {
      localStorage.setItem(STORAGE_SUBSCRIBED, 'true');
    } catch (e) {}
  }

  function isDismissed() {
    try {
      var until = parseInt(localStorage.getItem(STORAGE_DISMISSED_UNTIL), 10);
      return !!until && Date.now() < until;
    } catch (e) {
      return false;
    }
  }

  function markDismissed(days) {
    try {
      var ms = (days || 7) * 24 * 60 * 60 * 1000;
      localStorage.setItem(STORAGE_DISMISSED_UNTIL, String(Date.now() + ms));
    } catch (e) {}
  }

  function alreadyShownThisSession() {
    try {
      return sessionStorage.getItem(SESSION_SHOWN) === 'true';
    } catch (e) {
      return false;
    }
  }

  function markShownThisSession() {
    try {
      sessionStorage.setItem(SESSION_SHOWN, 'true');
    } catch (e) {}
  }

  function canShow() {
    return !isSubscribed() && !isDismissed() && !alreadyShownThisSession();
  }

  function showPopup(popup) {
    if (!popup || document.visibilityState !== 'visible') return;
    // Re-vérification au dernier moment : l'état a pu changer pendant le
    // délai d'attente (inscription/fermeture sur un autre onglet, etc.).
    if (!canShow()) return;

    markShownThisSession();
    popup.classList.add('is-visible');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('momkis-newsletter-popup-open');

    var input = popup.querySelector('.momkis-newsletter-popup__input');
    var closeBtn = popup.querySelector('[data-momkis-newsletter-close]');
    var focusTarget = input || closeBtn;
    if (focusTarget) focusTarget.focus();
  }

  function hidePopup(popup, remember, dismissDays) {
    if (!popup) return;
    popup.classList.remove('is-visible');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('momkis-newsletter-popup-open');
    if (remember) markDismissed(dismissDays);
  }

  function bindControls(popup, dismissDays) {
    var closeBtn = popup.querySelector('[data-momkis-newsletter-close]');
    var overlay = popup.querySelector('[data-momkis-newsletter-overlay]');
    if (closeBtn) closeBtn.addEventListener('click', function () { hidePopup(popup, true, dismissDays); });
    if (overlay) overlay.addEventListener('click', function () { hidePopup(popup, true, dismissDays); });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && popup.classList.contains('is-visible')) {
        hidePopup(popup, true, dismissDays);
      }
    });
  }

  function scheduleShow(popup, delayMs) {
    if (!canShow()) return;
    window.setTimeout(function () {
      showPopup(popup);
    }, delayMs);
  }

  function init() {
    var popup = getPopup();
    if (!popup) return;

    var delayMs = parseInt(popup.getAttribute('data-delay-ms'), 10) || 6000;
    var dismissDays = parseInt(popup.getAttribute('data-dismiss-days'), 10) || 7;

    bindControls(popup, dismissDays);

    // Retour d'un envoi réussi du formulaire natif (rechargement complet de
    // page) : mémoriser définitivement l'inscription et afficher une
    // dernière fois la popup pour montrer la confirmation, sans attendre le
    // délai ni revérifier le consentement (l'utilisateur vient d'agir
    // volontairement).
    if (popup.hasAttribute('data-posted-successfully')) {
      markSubscribed();
      popup.classList.add('is-visible');
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('momkis-newsletter-popup-open');
      return;
    }

    if (!canShow()) return;

    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      // API Customer Privacy indisponible (cas non attendu en production) :
      // repli sur le délai simple plutôt que de bloquer indéfiniment.
      scheduleShow(popup, delayMs);
      return;
    }

    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (error || !window.Shopify.customerPrivacy) {
          scheduleShow(popup, delayMs);
          return;
        }

        if (window.Shopify.customerPrivacy.shouldShowBanner()) {
          // Choix cookies pas encore fait pour ce visiteur : on attend
          // l'événement natif, jamais de sondage du DOM ni de délai
          // arbitraire tant que rien n'a été décidé.
          document.addEventListener(
            'visitorConsentCollected',
            function () {
              scheduleShow(popup, delayMs);
            },
            { once: true }
          );
          return;
        }

        // Choix déjà fait (session précédente) ou région ne nécessitant
        // aucune bannière : rien à attendre, on programme normalement.
        scheduleShow(popup, delayMs);
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
